import type { MessageKey } from "@src/i18n/locale-catalog";
import type { Translate } from "@src/i18n/translate";
import type { EquationDiagnosticCode } from "@src/features/equation-editor/equation";

const diagnosticKeys: Record<EquationDiagnosticCode, MessageKey> = {
  "invalid-expression": "diagnosticInvalidExpression",
  "expression-resource-limit": "diagnosticExpressionResourceLimit",
  "evaluation-timeout": "diagnosticEvaluationTimeout",
  "evaluation-unavailable": "diagnosticEvaluationUnavailable",
};

export function diagnosticMessage(
  t: Translate,
  code: EquationDiagnosticCode,
): string {
  return t(diagnosticKeys[code]);
}
